module.exports = __webpack_public_path__ + "static/media/chargen.3fd2adac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/QED/chargen.jpg
// module id = 173
// module chunks = 0